// extracted by mini-css-extract-plugin
export default {"breadCrumb":"breadCrumb__jfRmU","header":"header__n3i8p","drawer":"drawer__QDWLQ","body":"body__tBBcx","scroller":"scroller__PXxGO","scrollY":"scrollY__ago_v"};